import React from 'react';
import styled from '@emotion/styled';
import Comps from '@owenscorning/react-library';
import { useSelector, useDispatch } from 'react-redux';

import BackButton from '../../shared/BackButton';
import CTAButton from '../../../CTAButton';
import InfoIcon from '../../../OC/oc-info-icon';
import { setFormData, getWarrantyDetails, propertyLookup } from '../redux/action';

const OrDivider = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.2rem;
  margin: 1.5rem 0;

  &::before,
  &::after {
    content: '';
    border-bottom: 1px solid #d1d1d1;
    align-self: center;
  }

  span {
    height: 25px;
    width: 25px;
    background: #6d6d6d;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-size: 16px;
    color: #fff;
  }
`;

const Select = Comps.Connect.FormElements.Select;
const TextInput = Comps.Connect.FormElements.Text;

let months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const monthSelectOptions = () => {
  const monthOptions = months.map((month, index) => (
    <option key={month} value={index + 1}>
      {month}
    </option>
  ));
  const placeholder = <option disabled="" hidden value="false"></option>;

  return [placeholder, ...monthOptions];
};

const daySelectOptions = () => {
  const dayOptions = Array.from(Array(31).keys()).map((day, index) => (
    <option key={day} value={index + 1}>
      {index + 1}
    </option>
  ));
  const placeholder = <option disabled="" hidden value="false"></option>;

  return [placeholder, ...dayOptions];
};

const yearSelectOptions = () => {
  const getCurrentYear = new Date().getFullYear();
  const yearOptions = Array.from(Array(50).keys()).map((year, index) => (
    <option key={year} value={getCurrentYear - index}>
      {getCurrentYear - index}
    </option>
  ));
  const placeholder = <option disabled="" hidden value="false"></option>;

  return [placeholder, ...yearOptions];
};

const RoofInstallDate = () => {
  const {formData, isFetching} = useSelector(state => state)


  const dispatch = useDispatch();

  const enableBtn = () => {
    if (
      (formData.roofInstallDate.day &&
        formData.roofInstallDate.month &&
        formData.roofInstallDate.year) ||
      formData.warrantyRegistrationNumber
    ) {
      return false;
    }

    return true;
  };

  const handleClick = () => {
    if (formData?.warrantyRegistrationNumber) {
      dispatch(getWarrantyDetails())
    } else {
      if (formData.roofInstallDate.day && formData.roofInstallDate.month && formData.roofInstallDate.year) {
        dispatch(propertyLookup())
      }
    }
  }

  return (
    <>
      <BackButton
        analytics={{
          "data-track": "form-back",
          "data-track-form-name": "Submit Claim",
          "data-track-form-step": "step 2 - roof install date"
        }}
        onClick={() =>  dispatch(setFormData({showRoofInstallDate: false}))}
        backText={'What is the property address?'}
      />
      <p>So we know who to file this under,</p>
      <h4 className="mb20">Please provide one of these details: </h4>

      <h4>Roof Install Date</h4>

      <div className="twoFields">
        <div className="inputWrap mr10">
          <Select
            invalidInput={false}
            options={monthSelectOptions()}
            placeHolderText={'Month'}
            onChange={month => {
              dispatch(
                setFormData({
                  roofInstallDate: {
                    ...formData.roofInstallDate,
                    month,
                  },
                })
              );
            }}
            selected={formData.roofInstallDate.month || ''}
          />
        </div>
        <div className="inputWrap ml10">
          <Select
            invalidInput={false}
            options={daySelectOptions()}
            placeHolderText={'Day'}
            onChange={day => {
              dispatch(
                setFormData({
                  roofInstallDate: {
                    ...formData.roofInstallDate,
                    day,
                  },
                })
              );
            }}
            selected={formData.roofInstallDate.day || ''}
          />
        </div>
      </div>

      <div className="inputWrap">
        <Select
          invalidInput={false}
          options={yearSelectOptions()}
          placeHolderText={'Year'}
          onChange={year => {
            dispatch(
              setFormData({
                roofInstallDate: {
                  ...formData.roofInstallDate,
                  year,
                },
              })
            );
          }}
          selected={formData.roofInstallDate.year || ''}
        />
      </div>

      <OrDivider>
        <span>or</span>
      </OrDivider>

      <h4>Warranty Registration Number</h4>
      <div>
        <TextInput
          name="warrantyRegistrationNumber"
          value={formData.warrantyRegistrationNumber || ''}
          htmlAttributes={{
            placeholder: 'Enter Number',
          }}
          onChange={value =>
            dispatch(
              setFormData({
                warrantyRegistrationNumber: value,
              })
            )
          }
        />
        <span className="infoText">
          <InfoIcon color="#585858" /> Ex: OC-2018-WR-123456
        </span>
      </div>

      <CTAButton
        onClick={handleClick}
        data-track="form-next"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 2 - roof install date"
        element="button"
        text={isFetching ? 'Loading' : 'Next'}
        type="submit"
        disabled={enableBtn()}
      />
    </>
  );
};

export default RoofInstallDate;
